import { SoundOutlined } from "@ant-design/icons";
import lightningIcon from "~/public/static/icons/lightning@2x.png";
import priceIcon from "~/public/static/icons/price@2x.png";

const GroupMark = ({ group }: any) => (
  <>
    {group.featured && (
      <div className="group-type">
        <img
          src={lightningIcon.src}
          alt="精选"
        />
        <span>精选</span>
      </div>
    )}
    {group.paid && (
      <div className="group-type group-type-pay">
        <img
          src={priceIcon.src}
          alt="付费"
        />
        <span>付费</span>
      </div>
    )}
    {group.recent && (
      <div className="group-type group-type-new">
        <SoundOutlined />
        <span className="ml-5">新群</span>
      </div>
    )}
  </>
);

export default GroupMark;
